import '../scss/style.scss';
import Swup from 'swup';
import SwupScrollPlugin from '@swup/scroll-plugin';
import StickyController from "./components/StickyController";
import Form from "./components/Form";
import Blog from "./components/Blog";
import TabController from "./components/TabController";
import SearchController from "./components/SearchController";
import Accordion from "./components/Accordion";
import MobileNavigationSearch from "./components/MobileNavigationSearch";
import MobileNavigation from "./components/MobileNavigation";
import Favorites from "./components/Favorites";
import SwiperController from "./components/SwiperController";
import DropdownController from "./components/DropdownController";
import TiltController from "./components/TiltController";
import SlimSelectController from "./components/SlimSelectController";
import HomeHeroController from "./components/HomeHeroController";
import ScrollamaController from "./components/ScrollamaController";
import AccountForms from "./components/AccountForms";
import AgeGateController from "./components/AgeGateController";
import {ScrollTo} from "./components/ScrollTo";
import TestimonialLoadMore from "./components/TestimonialLoadMore";
import StorepointInitialDelete from "./components/StorepointInitialDelete";
import ProductModalController from "./components/ProductModalController";
import RedirectModal from "@/components/RedirectModal";
import FeaturedProductsSlider from "./components/FeaturedProductsSlider";


function docReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {
    classes();

    const swup = new Swup({
        plugins: [new SwupScrollPlugin({
            doScrollingRightAway: false,
            animateScroll: false,
        })],
        animateHistoryBrowsing: true,
    });

    swup.on('contentReplaced', () => {
        classes();

        const locatorWrapper = document.querySelector('#storepoint-container');
        if (locatorWrapper) {
            var a = document.createElement("script");
            a.type = "text/javascript";
            a.async = !0;
            a.src = "https://cdn.storepoint.co/api/v1/js/1666c960c2ed6a.js";
            var b = document.getElementsByTagName("script")[0];
            b.parentNode.insertBefore(a, b);
        }

        reinitCf7();
    });

    swup.on('transitionEnd', () => {
        new SlimSelectController();
    });

});

function reinitCf7() {
    let forms = document.querySelectorAll('.wpcf7-form');

    forms.forEach((element) => {
        wpcf7.init(element);

        if (wpcf7.cached) {
            wpcf7.refill(element);
        }
    });
}

const classes = () => {
    new AgeGateController();
    new StickyController('.js-sticky-element');
    new Favorites();
    new Blog();
    new Accordion();
    new MobileNavigationSearch();
    new MobileNavigation();
    new SearchController();
    new TiltController();
    new HomeHeroController();
    new AccountForms();
    new TabController();
    new SwiperController();
    new DropdownController();
    // new SlimSelectController();
    new ScrollTo();
    new TestimonialLoadMore();
    new StorepointInitialDelete();
    new ProductModalController();
    new FeaturedProductsSlider();

    let newsletterForm = new Form();
    newsletterForm.init();

    const redirectModal = new RedirectModal();
    redirectModal.init();

    // Needed for later init to calculatte correct offset
    setTimeout(()=>{
        new ScrollamaController();
    }, 300);

};
